import React, { Component } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CCardFooter,
    CCol,
    CRow,
    CButton,
    CLabel,
    CForm,
    CFormGroup,
    CInput,
    CInvalidFeedback,
    CTextarea,
    CSelect,
    CInputCheckbox,
    CFormText,
    CModal,
    CModalHeader,
    CModalBody,
    CModalFooter,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { helps } from 'src/_helpers';

class DocCategoriesForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: {},
            errors: {},
            id: '',
            name: '',
            code: '',
            create_by: this.props.user.id,
            create_date: new Date(),
            description: '',
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        const { item, category } = this.props;
        console.log(item);
        if (item !== 'add' && category) {
            this.setState({
                id: category.id,
                name: category.name ? category.name : this.state.name,
                code: category.code ? category.code : this.state.code,
                description: category.description ? category.description : this.state.description,
                create_by: category.create_by ? category.create_by : this.props.user.id,
                create_date: category.create_date ? category.create_date : new Date(),
            });
        } else if (item === 'add') {
            this.clearFrom();
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            let category = {
                id: this.state.id,
                name: this.state.name,
                code: this.state.code,
                create_by: this.state.create_by,
                create_date: new Date(this.state.create_date),
            }
            this.props.handleSubmit(category);
            this.clearFrom();
        } else {
            return false;
        }
    }

    clearFrom() {
        this.setState({
            id: '',
            name: '',
            code: '',
            description: '',
        });
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        if (field === 'code') {
            fields[field] = fields[field].replace(/ /g, '-');
        }
        this.setState({
            [field]: fields[field]
        });
        this.setState({ fields });
    }

    checkCode(code) {
        const { categories } = this.props;
        let foundCat = helps.getItemFromArr(categories, code, 'code');
        return helps.isEmpty(foundCat);
    }

    handleValidation() {
        let errors = {};
        let formIsValid = true;

        if (helps.isEmpty(this.state.name)) {
            formIsValid = false;
            errors["name"] = "Vui lòng nhập Tên Nhóm!";
        }

        if (helps.isEmpty(this.state.code)) {
            formIsValid = false;
            errors["code"] = "Vui lòng nhập Viết tắt!";
        } else {
            if (!this.checkCode(this.state.code)) {
                formIsValid = false;
                errors["code"] = "Viết tắt đã được dùng, vui lòng nhập Viết tắt khác!";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }


    render() {
        let item = !helps.isEmpty(this.props.item) ? this.props.item : 'add';
        return (
            <CModal
                key={'modal-' + item}
                size='lg'
                show={this.props.modals.includes(item)}
                onClose={() => { this.props.toggleModal(item) }}
                className='text-left'
            >
                <CModalHeader closeButton>
                    <div>
                        <h3>{this.props.form_header}</h3>
                    </div>
                </CModalHeader>
                <CModalBody>
                    <CRow>
                        <CCol xl={12}>
                            <CForm onSubmit={(e) => this.handleSubmit(e)}>

                                <CRow>
                                    <CCol md={12}>
                                        <div className="mb-3">
                                            <CLabel htmlFor="input-name">Tên Nhóm:</CLabel>
                                            <CInput
                                                type="text"
                                                name="name"
                                                id="input-name"
                                                value={this.state.name}
                                                required
                                                className='font-weight-bold'
                                                onChange={(e) => { this.handleChange('name', e) }}
                                            />
                                            <small className="text-danger text-danger font-italic">{this.state.errors['name']}</small>
                                        </div>
                                        <div className="mb-3">
                                            <CLabel htmlFor="input-code">Viết tắt:</CLabel>
                                            <CInput
                                                type="text"
                                                name="code"
                                                id="input-code"
                                                value={this.state.code}
                                                required
                                                className='font-weight-bold'
                                                onChange={(e) => { this.handleChange('code', e) }}
                                            />
                                            <small className="text-danger text-danger font-italic">{this.state.errors['code']}</small>
                                        </div>
                                        <div className="mb-3">
                                            <CLabel htmlFor="input-description">Mô tả:</CLabel>
                                            <CTextarea
                                                id="input-description"
                                                name="description"
                                                rows={10}
                                                value={this.state.description}
                                                onChange={(e) => { this.handleChange('description', e) }}
                                            >
                                            </CTextarea>
                                            <small className="help-block text-danger font-italic">{this.state.errors['description']}</small>
                                        </div>
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCol>
                    </CRow >
                </CModalBody>
                <CModalFooter>
                    <CRow className="mb-3">
                        <CCol md={12}>
                            <CButton type="button" size='sm' color="primary" onClick={(e) => this.handleSubmit(e)}>
                                <CIcon name="cil-save" className="mfe-1 mt-0"></CIcon>
                                Lưu
                            </CButton>
                            <CButton type="button" size='sm' color="secondary" onClick={this.props.toggleModal} className="ml-3">
                                <CIcon name="cil-x-circle" className="mfe-1 mt-0"></CIcon>
                                Huỷ
                            </CButton>
                        </CCol>
                    </CRow>
                </CModalFooter>
            </CModal>
        )
    }
}
export default DocCategoriesForm;

